import { Link } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import EditRoundedIcon from '@mui/icons-material/EditRounded';

const EditButton = ({
  title = 'Edit',
  href = '',
  size = 'small',
  color = 'secondary',
}) => {
  return (
    <Tooltip title={title}>
     <IconButton LinkComponent={Link} to={href} color={color} size={size}>
      <EditRoundedIcon />
    </IconButton>
    </Tooltip>
  )
};

export default EditButton;